import { render, staticRenderFns } from "./expenditures.vue?vue&type=template&id=41aa265e&"
import script from "./expenditures.vue?vue&type=script&lang=js&"
export * from "./expenditures.vue?vue&type=script&lang=js&"
import style0 from "./expenditures.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports